import { render } from "./ComplexProjectCard.vue?vue&type=template&id=3567786a&scoped=true"
import script from "./ComplexProjectCard.vue?vue&type=script&lang=js"
export * from "./ComplexProjectCard.vue?vue&type=script&lang=js"

import "./ComplexProjectCard.vue?vue&type=style&index=0&id=3567786a&scoped=true&lang=css"

import exportComponent from "/home/leandro/trabalho-timo/kuhlenbier-web-frontend-partner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3567786a"]])

export default __exports__